import { useQuery } from '@tanstack/react-query';
import type { Artist } from '@/lib/api-admin/types';
import { apiClient } from '@/lib/apiClient';

export const artistQueryKey = (artistId: string) =>
  ['admin', 'artist', artistId] as const;

export const useArtistQuery = (artistId: string | undefined) =>
  useQuery<Artist>({
    queryKey: artistQueryKey(artistId ?? ''),
    enabled: Boolean(artistId),
    queryFn: async () => {
      const [data] = await apiClient.request('get', '/admin/v1/artists/{artistId}', {
        params: { path: { artistId: artistId as string } },
      });
      return data as Artist;
    },
  });
